import React, { useEffect, useState } from 'react'
import { Col, Icon, Panel, Rate, Row } from 'rsuite'
import MAndEWorkerForm from './MAndEWorkerForm'
import {
  buildFilteredTree,
  getLabelsWithParents,
  loadLocation,
} from '../../components/location/Location'
import RenderLocationTree from './RenderLocationTree'
import MAndEProjectInfo from './MAndEProjectInfo'

export default function MAndEView({ schema: _schema, ...props }) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [location, setLocation] = useState([])

  useEffect(() => {
    let assessment = _schema?.assessment?.datas || []

    if (isLocation(assessment)) {
      handleLocation()
    }
  }, [_schema])

  const handleLocation = async () => {
    let locationJson = await loadLocation()

    setLocation(locationJson || [])
  }

  const isLocation = (datas) => {
    var result = []

    var obj = datas?.find((e) => ['7', '8'].includes(e.selection?.type))

    if (obj) {
      return true
    } else {
      for (let item of datas) {
        if (item.children?.length > 0) {
          var childResult = isLocation(item.children)
          if (childResult) {
            return childResult
          }
        }

        return false
      }
    }

    return result
  }

  const renderAssessment = (datas, isTab) => {
    return (
      <>
        {datas?.map((data, index) => {
          return (
            <Panel
              bordered
              key={data.id}
              style={{ marginBottom: 10, marginLeft: isTab ? 10 : 0 }}
              collapsible
              defaultExpanded
              header={data.label}
            >
              {data.selection && (
                <>
                  {data.selection.type == '1' && (
                    <>
                      {data.selection.options?.map((item, index) => {
                        return (
                          <p>
                            <Icon
                              icon={
                                data.selection.value == item.value ? 'check-square' : 'square-o'
                              }
                              size="lg"
                              style={{ marginRight: 10 }}
                            />
                            <label
                              dangerouslySetInnerHTML={{ __html: item.label }}
                              style={{ marginTop: -3 }}
                            />
                          </p>
                        )
                      })}
                    </>
                  )}

                  {data.selection.type == '2' && (
                    <>
                      {data.selection.options?.map((item, index) => {
                        return (
                          <p>
                            <Icon
                              icon={
                                data.selection.value?.includes(item.value)
                                  ? 'check-square'
                                  : 'square-o'
                              }
                              size="lg"
                              style={{ marginRight: 10 }}
                            />
                            <label
                              dangerouslySetInnerHTML={{ __html: item.label }}
                              style={{ marginTop: -3 }}
                            />
                          </p>
                        )
                      })}
                    </>
                  )}

                  {['3', '4', '5'].includes(data.selection.type) && (
                    <>
                      <div
                        dangerouslySetInnerHTML={{ __html: data.selection.value }}
                        style={{ marginTop: -3 }}
                      />
                    </>
                  )}

                  {'6' == data.selection.type && (
                    <>
                      <Row style={{ textAlign: 'center' }}>
                        <Rate
                          max={data.selection.maximum}
                          classPrefix="rs-rate rs-rate-size-xl"
                          value={data.selection.value || 0}
                        />
                      </Row>
                    </>
                  )}

                  {'7' == data.selection.type && (
                    <>
                      <Row>
                        <ul>
                          {getLabelsWithParents(location, data.selection.value?.split(','))?.map(
                            (e) => {
                              return <li key={e}>{e}</li>
                            }
                          )}
                        </ul>
                      </Row>
                    </>
                  )}

                  {'8' == data.selection.type && (
                    <>
                      <Row>
                        <RenderLocationTree
                          data={buildFilteredTree(location, data.selection.value)}
                        />
                      </Row>
                    </>
                  )}
                </>
              )}

              {data.qualitativeData && (
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <b>{data.qualitativeData.label}</b>
                  </Col>
                  <Col style={{ marginLeft: 10 }}>
                    {data.qualitativeData.value || '- ไม่ระบุ -'}
                  </Col>
                </Row>
              )}
              {data.evaluationTeamReflect && (
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <b>{data.evaluationTeamReflect.label}</b>
                  </Col>
                  <Col style={{ marginLeft: 10 }}>
                    {data.evaluationTeamReflect.value || '- ไม่ระบุ -'}
                  </Col>
                </Row>
              )}
              {data.change && (
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <b>{data.change.label}</b>
                  </Col>
                  <Col style={{ marginLeft: 10 }}>{data.change.value || '- ไม่ระบุ -'}</Col>
                </Row>
              )}

              {data.children?.length > 0 && renderAssessment(data.children, true)}
            </Panel>
          )
        })}
      </>
    )
  }

  return (
    <>
      <MAndEProjectInfo schema={formSchema} />

      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{formSchema.assessmentType.label} : </b>
          {formSchema.assessmentType.valueDef}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{formSchema.reportor.label} : </b>
          {formSchema.reportor.value}
        </Col>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{formSchema.startDate.label} : </b>
          {formSchema.startDate.value}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b> {formSchema.endDate.label} : </b>
          {formSchema.endDate.value}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10 }}>
          <b> {formSchema.managementUnitType.label} : </b>
          {formSchema.managementUnitType.valueDef}
        </Col>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <b> {formSchema.managementUnitHead.label} : </b>
          {formSchema.managementUnitHead.value}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10 }}>
          <b> {formSchema.mentorCount.label} : </b>
          {formSchema.mentorCount.value}
        </Col>
      </Row>

      {formSchema.workingGroup && <MAndEWorkerForm isView schema={formSchema.workingGroup} />}

      <Row style={{ marginTop: 10 }}>
        <Col>
          <b>{formSchema.assessment.header}</b>
        </Col>
      </Row>

      {renderAssessment(formSchema.assessment.datas || [], false)}
    </>
  )
}
